import type { ControlDataSchema } from '@/api/main/types.gen'

// Old map-ui ordering: `control_data_next` first, `control_data_vehicle` second,
// everything else by schema_name descending (newest first).
const PINNED_ORDER = ['control_data_next', 'control_data_vehicle'] as const

export const sortControlSchemas = <T extends Pick<ControlDataSchema, 'schema_name'>>(schemas: T[]): T[] => {
  const pinned: T[] = []
  for (const name of PINNED_ORDER) {
    const match = schemas.find(s => s.schema_name === name)
    if (match) pinned.push(match)
  }
  const rest = schemas
    .filter(s => !PINNED_ORDER.includes(s.schema_name as (typeof PINNED_ORDER)[number]))
    .sort((a, b) => b.schema_name.localeCompare(a.schema_name))
  return [...pinned, ...rest]
}
